"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _renderCustomHeader = require("./renderCustomHeader");

var _default = _renderCustomHeader.renderCustomHeader;
exports["default"] = _default;